import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { UsersSelectors } from '../../../Redux/modules/users/selectors';
import styles from './UsageContainer.module.less';
import UsagePerUser from '../components/UsagePerUser';
import { AppSelectors } from '../../../Redux/modules/app/selectors';
import { UsageSelectors } from '../../../Redux/modules/usage/selectors';
import Tabs from '../../Tabs/Tabs';
import { UsageActions } from '../../../Redux/modules/usage/actions';

const UsagePerUserContainer = (props) => {
  return (
    <>
      <Tabs tabs={[{ title: gettext('Usage per user'), link: 'usage/per-user/' }]} />
      <div className={styles.section}>
        <div className={styles.sectionDiv}>
          <UsagePerUser
            teams={props.teams}
            timeFilter={props.timeFilter}
            requestExport={props.requestExport}
            isTeamManagement={props.isTeamManagement}
            isLoading={props.isLoadingUsage || props.isLoadingUsers}
            filteredUsageData={props.filteredUsageData}
            getExportRequestStatus={props.getExportRequestStatus}
            isExportRequestReady={props.isExportRequestReady}
            exportRequestId={props.exportRequestId}
            isExportLoading={props.isExportLoading}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isTeamManagement: AppSelectors.isTeamManagementSelector(state),
    teams: UsersSelectors.teamsSelector(state),
    timeFilter: UsageSelectors.timeFilterSelector(state),
    isLoadingUsage: UsageSelectors.isLoadingUsageSelector(state),
    isLoadingUsers: UsersSelectors.isLoadingUsersSelector(state),
    filteredUsageData: UsageSelectors.filteredUsageDataSelector(state),
    isExportRequestReady: UsageSelectors.isExportRequestReadySelector(state),
    exportRequestId: UsageSelectors.exportRequestIdSelector(state),
    isExportLoading: UsageSelectors.isExportLoadingSelector(state),
  };
};

const mapDispatchToProps = {
  requestExport: UsageActions.exportUsageList,
  getExportRequestStatus: UsageActions.exportUsageListInProgress,
};

UsagePerUserContainer.propTypes = {
  teams: PropTypes.array,
  timeFilter: PropTypes.object,
  requestExport: PropTypes.func,
  isTeamManagement: PropTypes.bool,
  isLoadingUsers: PropTypes.bool,
  isLoadingUsage: PropTypes.bool,
  filteredUsageData: PropTypes.array,
  getExportRequestStatus: PropTypes.func,
  isExportRequestReady: PropTypes.bool,
  exportRequestId: PropTypes.string,
  isExportLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsagePerUserContainer);
